import {createAsyncThunk} from '@reduxjs/toolkit';
import apiInstance, {apiInstanceID} from '../../Apis/Axios';
import { FOODIE_MENU_SERVICE } from '../EndPoints';

export const GetAllCafeterias = createAsyncThunk('shift/getAllCafeterias', async () => {
    const result = await apiInstanceID.get(FOODIE_MENU_SERVICE.getAllCafeterias).then(function (response) {
        return response;
    })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetAllCafeteriasByUserId = createAsyncThunk('shift/getAllCafeteriasByUserId', async () => {
    const result = await apiInstanceID.get(FOODIE_MENU_SERVICE.getAllCafeteriasByUserId).then(function (response) {
        return response;
    })
        .catch(function (error) {
            return error.response;
        });
    const { data, status } = result;

    return { data, status };
});

export const GetShiftById = createAsyncThunk('shift/getShiftById', async (params, { dispatch, getState }) => {
    const response = await apiInstance.get(`${FOODIE_MENU_SERVICE.getShiftById}${params}`).then((response) => {
        return response;
    })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;
    return { data, status };
});

export const CreateShift = createAsyncThunk("shift/createShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.post(FOODIE_MENU_SERVICE.createShift, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

export const UpdateShift = createAsyncThunk("shift/updateShift",async (params, { dispatch, getState }) => {

    const response = await apiInstance.put(FOODIE_MENU_SERVICE.updateShift, params).then(function (response) {
        return response
    }).catch(function (error) {
        return error.response
    })
    const { data, status } = response

    return { data, status }
});

// Not-assigned foodie shift resources (Read). Body:
// { pagination:{page,size}, model, resourceId, resourceString, key }. Used by
// the Add tab in update mode so the catalog excludes already-assigned items.
// Mirrors AttendanceShift GetShiftResourceNotAssigned.
export const GetFoodieShiftResourceNotAssigned = createAsyncThunk('shift/getFoodieShiftResourceNotAssigned', async (body) => {
    const response = await apiInstance.post(FOODIE_MENU_SERVICE.getFoodieShiftResourceNotAssigned, body).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });
    const { data, status } = response;
    return { data, status };
});

// Assigned foodie shift resources (CustomRead). Body:
// { pagination:{page,size}, model, resourceId, resourceString } (key must be null).
// Uniform shape discriminated by foodieShiftResourceMode.
// Mirrors AttendanceShift GetShiftResourceAssigned.
export const GetFoodieShiftResourceAssigned = createAsyncThunk('shift/getFoodieShiftResourceAssigned', async (body) => {
    const response = await apiInstance.post(FOODIE_MENU_SERVICE.getFoodieShiftResourceAssigned, body).then((response) => {
        return response;
    }).catch((error) => {
        return error.response;
    });
    const { data, status } = response;
    return { data, status };
});

export const GetCustomAccessByShiftIdFoodie = createAsyncThunk('shift/getCustomAccessByShiftId', async (params) => {
    const response = await apiInstance
        .post(`${FOODIE_MENU_SERVICE.getCustomAccessByShiftIdFoodie}${params.id}`, params?.body)
        .then((response) => {
            return response;
        })
        .catch((error) => {
            return error.response;
        });
    const { data, status } = response;

    return { data, status };
});
